import { render, staticRenderFns } from "./addGateway.vue?vue&type=template&id=0576397c"
import script from "./addGateway.vue?vue&type=script&lang=js"
export * from "./addGateway.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports